import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mb-9" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h4", null, "Notification Preferences", -1)
const _hoisted_3 = { class: "mt-6" }
const _hoisted_4 = { class: "mb-6" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h4", null, "Delete your account", -1)
const _hoisted_6 = { class: "md:flex justify-between" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "md:w-3/5" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "mb-2 text-sm md:text-base" }, " If you delete your account you will no longer be able to access your saved challenges, ideas and plans ")
], -1)
const _hoisted_8 = { class: "mt-6 md:mt-0 flex justify-end items-center" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", null, " Are you sure you want to delete your account? This can't be undone. ", -1)
const _hoisted_10 = { class: "flex justify-center mt-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Editorial = _resolveComponent("Editorial")!
  const _component_UserSettingsItem = _resolveComponent("UserSettingsItem")!
  const _component_AppButton = _resolveComponent("AppButton")!
  const _component_ModalContent = _resolveComponent("ModalContent")!
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_Editorial, null, {
        default: _withCtx(() => [
          _hoisted_2
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_UserSettingsItem, {
          "settings-default": false,
          "settings-key": "notifications_email",
          label: "Email notifications",
          "help-text": "Email updates about your activity in the app"
        }),
        _createVNode(_component_UserSettingsItem, {
          "settings-default": false,
          "settings-key": "notifications_marketing",
          label: "Email updates",
          "help-text": "Information and updates about new Sport Sparks features"
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", null, [
        _createVNode(_component_Editorial, null, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_AppButton, {
            type: "primary",
            onClick: _cache[0] || (_cache[0] = () => _ctx.showModal('deleteAccount'))
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Delete account ")
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _createVNode(_component_Modal, {
      modelValue: _ctx.isShown.deleteAccount,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.isShown.deleteAccount) = $event)),
      close: () => _ctx.closeModal('deleteAccount')
    }, {
      default: _withCtx(() => [
        _createVNode(_component_ModalContent, {
          close: () => _ctx.closeModal('deleteAccount'),
          title: "Delete account",
          class: "md:max-w-xl"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_Editorial, null, {
              default: _withCtx(() => [
                _hoisted_9,
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(_component_AppButton, {
                    class: "mr-6",
                    type: "secondary",
                    onClick: _cache[1] || (_cache[1] = () => _ctx.closeModal('deleteAccount'))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Cancel ")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_AppButton, {
                    type: "danger",
                    "is-loading": _ctx.isDeletingUser,
                    onClick: _ctx.handleDeleteAccount
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Delete ")
                    ]),
                    _: 1
                  }, 8, ["is-loading", "onClick"])
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["close"])
      ]),
      _: 1
    }, 8, ["modelValue", "close"])
  ], 64))
}